import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography, TypographyProps } from '@mui/material';

export interface IProps extends TypographyProps {
  icon: React.ReactNode;
  text: string;
  className?: string;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    fontWeight: 600,
    marginLeft: theme.spacing(1),
    textTransform: 'uppercase',
  },
}));

const IconWithText: React.FC<React.PropsWithChildren<IProps>> = ({
  icon,
  text,
  className,
  color = 'primary',
  ...props
}) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.root}>
      {icon}
      <Typography className={cx(classes.text, className)} color={color} {...props}>
        {text}
      </Typography>
    </div>
  );
};

export default memo(IconWithText);
